import { Component, OnChanges, OnInit } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { AppService } from 'src/app/services/app.service';
import { RfqService } from 'src/app/services/rfq.service';
import { SCESupplyService } from 'src/app/services/sce-supply.service';
import { SelfServeService } from 'src/app/services/self-serve.service';
import { CommonService } from 'src/app/shared/common.service';
import { environment } from 'src/environments/environment';
import { NavbarComponent } from '../navbar/navbar.component';

@Component({
  selector: 'app-pickup-l1',
  templateUrl: './pickup-l1.component.html',
  styleUrls: ['./pickup-l1.component.css']
})
export class PickupL1Component implements OnInit {
  chart: Chart;
  dateRanges = { start_date: new Date(), end_date: new Date() };
  DateCalender: any;
  regions: any = [];
  public selectedRegions = [];
  TeamRegionsListObj: any = {};
  dropdownSettings = {};
  dateRange: any;
  userId_val: any;
  quotePendancyChart: any;
  RkeyValue: any;
  reportName: any;
  GMData: any[];
  otifGraph: Chart;
  OTIFData: any[];

  constructor(private commonService: CommonService, private service: SelfServeService, private rfqService: RfqService, private sceService: SCESupplyService, private appService: AppService, private navbarTitle: NavbarComponent) {
    this.userId_val = this.appService.userDetails.email;
    this.reportName = this.navbarTitle.reportlabel;
    this.getFiltersData();
    this.multiSelectDropdown();
  }

  ngOnInit() {
  }

  calculateDateRange(value: Date): void {
    if (value) {
      var diff = Math.floor((Date.parse(value[1]) - Date.parse(value[0])) / 86400000);
      if(diff + 1 > 185) {
        this.commonService.showToast('max allowable date range is 3 months', 3);
        setTimeout(() => {
          this.dateRange = null;
        }, 100);
      }
    }
  }
  multiSelectDropdown() {
    this.dropdownSettings = {
      singleSelection: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      itemsShowLimit: 1
    };
  }

  getFiltersData() {
    this.rfqService.getFiltersItemTrackingES(this.userId_val).subscribe(filtersRes => {
      this.TeamRegionsListObj = filtersRes["data"];
      this.regions = Object.keys(filtersRes["data"]);
    });
  }

  onRegionSelect(item: string) {
  }
  onRegionsAll(items: any) {
    this.selectedRegions = this.regions;
  }
  onRegionDeSelect(deselectedSID: any): void {
    this.selectedRegions = this.selectedRegions.filter(s => s != deselectedSID);
  }
  onRegionsDeSelectAll(items: any) {
  }
  getDateFormat(date, isLast = false) {
    date = new Date(date);
    if (!date) return;
    if(isLast) {
      date.setDate(date.getDate() + 1);
    }
    date = new Date(date);
    return date.getFullYear() + '-' + this.appendZero((date.getMonth() + 1)) + '-' + this.appendZero(date.getDate());
  }
  appendZero(number) {
    if (number > 9) {
      return number;
    } else {
      return '0' + number;
    }
  }

  generateReports() {
    const payload = this.generatePayload();
    this.generateQuotePendancyGraph(payload);
    this.generateOTIFGraph(payload);
    let reportRequest = {'username':this.userId_val,'report_name':this.reportName};
    this.appService.saveInfo(environment.user_tracking_api,reportRequest).subscribe(reportdata=>{})
  }

  generateOTIFGraph(payload) {
    const url = 'https://analysis.moglix.com/supp_dashboard/l1/otif';
    this.rfqService.postCall(url, payload).subscribe(resp => {
      this.generateOTIFChart(resp);
    })
  }

  generateQuotePendancyGraph(payload) {
    const url = 'https://analysis.moglix.com/supp_dashboard/l1/first_pickup_adherence';
    this.rfqService.postCall(url, payload).subscribe(resp => {
      this.generateQuotePendancyChart(resp);
    })
  }
  generatePayload() {
    const payload = {
      "start_date": this.getDateFormat(this.dateRange[0]),
      "end_date": this.getDateFormat(this.dateRange[1], true),
      "regions": this.selectedRegions,
      "username": this.userId_val,
    }
    return payload;
  }

  generateValuesForGraph(data, x = 'X') {
    const values = [];
    const categories = [];
    if (data && data.length) {
      data.forEach(element => {
        if(element['Y'] > 100) {
          values.push((+element['Y'] / 100000));
        } else {
          values.push(element['Y'] || 0);
        }
        categories.push(element[x]);
      });
    }
    return {
      values: values,
      categories: categories
    };
  }

  generateQuotePendancyChart(data?) {
    const gm_percent = this.generateValuesForGraph(data['data']['first_pickup_adherence']);
    const options: any = {
      chart: {
        type: 'line',
        height: 400,
      },
      title: {
        text: 'First Pick up Adherance'
      },
      xAxis: {
        categories: gm_percent.categories,
      },
      yAxis: [{ // Primary yAxis
        gridLineWidth: 0,
        labels: {
          format: '{value}%',
          style: {},
          enabled: true
        },
        title: {
          text: '',
          style: {}
        },
        // height: '50%',
        min: 0

      }, 
    ],
      plotOptions: {
        series: {
          lineWidth: 4,
        }
      },
      tooltip: {
        shared: false,
        useHTML: true
      },
      series: [
      {
        name: 'First Pickup %',
        color: 'blue',
        type: 'column',
        data: gm_percent.values,
      }
    ]
    }
    this.quotePendancyChart = new Chart(options);
    this.GMData = this.sceService.post(data.data.raw_data)['excel'];
  }

  exportAsXLSX1(): void {
    this.service.exportAsExcelFile(this.GMData, 'Pickup Adherance L1');
  }

  generateOTIFChart(data?) {
    const gm_percent = this.generateValuesForGraph(data['data']['otif_percent']);
    const options: any = {
      chart: {
        type: 'line',
        height: 400,
      },
      title: {
        text: 'OTIF-Chart'
      },
      xAxis: {
        categories: gm_percent.categories,
      },
      yAxis: [{ // Primary yAxis
        gridLineWidth: 0,
        labels: {
          format: '{value}%',
          style: {},
          enabled: true
        },
        title: {
          text: '',
          style: {}
        },
        // height: '50%',
        min: 0

      }, 
    ],
      plotOptions: {
        series: {
          lineWidth: 4,
        }
      },
      tooltip: {
        shared: false,
        useHTML: true
      },
      series: [
      {
        name: 'OTIF %',
        color: 'blue',
        type: 'column',
        data: gm_percent.values,
      }
    ]
    }
    this.otifGraph = new Chart(options);
    this.OTIFData = this.sceService.post(data.data.raw_data)['excel'];
  }

  exportAsXLSX(): void {
    this.service.exportAsExcelFile(this.OTIFData, 'OTIF L1');
  }
}